import { mapState, mapActions } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const authMethods = mapActions('auth', ['logIn', 'logOut', 'register', 'resetPassword'])
export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const countriesComputed = { ...mapState('countries', {countries: (state) => state.countries })}
export const countriesMethods = mapActions('countries', ['fetchCountries'])

export const vendorComputed = { ...mapState('vendors', {vendors: (state) => state.vendors })}
export const vendorMethods = mapActions('vendors', ['fetchVendors'])

export const categorieComputed = { ...mapState('categories', {categories: (state) => state.categories })}
export const categorieMethods = mapActions('categories', ['fetchCategories'])

export const productComputed = { ...mapState('products', {products: (state) => state.products })}
export const productMethods = mapActions('products', ['fetchProducts','filterProducts','filterPrice','filterProductsByCategory','findProducts'])

export const cartComputed = { ...mapState('carts', {carts: (state) => state.carts })}
export const cartMethods = mapActions('carts', ['fetchCarts'])